import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const BoldBookIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.22453 17.88H15.9522C16.3343 17.88 16.6445 17.5698 16.6445 17.1877C16.6445 16.8055 16.3343 16.4954 15.9522 16.4954H7.22453C6.84238 16.4954 6.53223 16.8055 6.53223 17.1877C6.53223 17.5698 6.84238 17.88 7.22453 17.88Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.6964 6.26766L5.8592 6.27999V4.57846C5.8592 3.708 6.56905 3 7.44228 3H15.8865C17.9229 3 19.5789 4.656 19.5789 6.69231V17.1229C19.5803 17.1413 19.5811 17.1597 19.5811 17.1785C19.5811 19.2858 17.8651 21 15.7558 21H4.67886C3.80655 21 3.09579 20.2883 3.09579 19.4123V7.84612C3.09579 7.41966 3.26471 7.01904 3.57025 6.71904C3.87486 6.41996 4.28656 6.24735 4.6964 6.26766ZM15.7558 19.6154C17.0852 19.6154 18.1697 18.548 18.196 17.2275C18.1948 17.2112 18.1942 17.1949 18.1942 17.1785C18.1942 15.8289 17.0995 14.7323 15.7545 14.7323H7.44228C6.56905 14.7323 5.8592 14.0243 5.8592 13.1538V7.66478L4.6761 7.65227C4.61028 7.63187 4.57769 7.66746 4.55296 7.69447C4.54862 7.69926 4.54446 7.70377 4.5404 7.70766C4.51732 7.72981 4.4804 7.77689 4.4804 7.84612V19.4123C4.4804 19.5258 4.56809 19.6154 4.67886 19.6154H15.7558Z"
        fill={props.fill || "currentColor" || "black"}
      />
    </svg>
  );
};

export default BoldBookIcon;
